const html = {
	group: "block",
	attrs: {
		mode: { default: "iframe" },
		content: { default: "<p>HTML</p>" },
	},
};

export default html;
